import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: rgba(245, 248, 251, 1);
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
  gap: 24px;
`
export const Title = styled.div`
  font-family: Manrope;
  font-size: 18px;
  font-weight: 800;
  line-height: 34px;
  letter-spacing: 0em;
  text-align: left;
`